// strings/look.ts (M0-T06, §7.1) — swatch and choice names for the character creator and roof picker
import type { StringBank } from '../schema/strings';

export default {
  skin1: 'Shell', skin2: 'Peach', skin3: 'Honey', skin4: 'Caramel', skin5: 'Cocoa', skin6: 'Espresso',
  eyesRound: 'Round', eyesHappy: 'Happy', eyesSleepy: 'Sleepy', eyesSparkle: 'Sparkle',
  hairShort: 'Short', hairBob: 'Bob', hairBun: 'Bun', hairCurly: 'Curly', hairLong: 'Long', hairBuzz: 'Buzz',
  hairBlack: 'Black', hairBrown: 'Brown', hairChestnut: 'Chestnut', hairAuburn: 'Auburn', hairBlond: 'Blond', hairGinger: 'Ginger',
  hairGrey: 'Silver', hairLilac: 'Lilac',
  dyeCoral: 'Coral', dyeSky: 'Sky', dyeLilac: 'Lilac', dyeMarigold: 'Marigold', dyeTeal: 'Teal', dyeRose: 'Rose', dyeLeaf: 'Leaf',
  dyeClay: 'Clay', dyeMoss: 'Moss', dyePlum: 'Plum', dyeCream: 'Cream', dyeDenim: 'Denim', dyeCharcoal: 'Charcoal', dyeBrown: 'Brown',
  dyeWhite: 'White', dyeNavy: 'Navy',
  roofRed: 'Red roof', roofBlue: 'Blue roof', roofYellow: 'Yellow roof', roofGreen: 'Green roof',   // revision 10: the four kit roof colours
} as const satisfies StringBank;
